import React, { useRef, useState } from 'react'
import PortalTitle from '../../component/common/portal.title'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  Spin,
  Button,
  Card,
  message,
  Layout,
} from 'antd'
import { UserOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { Redirect, Link,useLocation,useHistory } from 'react-router-dom'
import '../../css/signin.scss'
import util from '../../util/util'
import { sendResetPasswordLink } from '../../store/action/user.action'
import { constants } from '../../constants'
import TurnstileWidget from '../../component/common/turnstile.widget'

var cardSize =
  (window.innerWidth < window.innerHeight
    ? window.innerWidth
    : window.innerHeight) - 20

cardSize = cardSize < 400 ? cardSize : 400

const ForgotPassword = (props) => {
    const location = useLocation();
    const  history = useHistory()
    const isAdminLite=location.search==constants.ADMIN_LITE;
  // Turnstile appears only once the server reports captcha_required — i.e. past
  // 3 reset requests from this IP within the hour. Mirrors the login form
  // (pages/signin/signin.js); the gate itself is business/resetrequestlimit.js.
  //
  // Counted per IP rather than per account on purpose: the response to this
  // form is identical whether or not the address exists, and a CAPTCHA that
  // appeared only for real accounts would give that away again.
  const [captchaRequired, setCaptchaRequired] = useState(false)
  const captchaTokenRef = useRef(null)
  const capchaResetRef = useRef(null)

  const onFinish = async (values) => {
    const result = await props.resetPassword(
      values.email ? values.email.toLowerCase() : values.email,
      captchaTokenRef.current
    )
    // Show the widget and clear any stale token so the next submission carries
    // a fresh one. Never a lock — solving it sends the link as normal.
    if (result && result.captcha_required) {
      setCaptchaRequired(true)
      if (capchaResetRef.current) capchaResetRef.current()
      captchaTokenRef.current = null
    }
  }
  const handleBack =  async() => {
    const path = `/login${constants.ADMIN_LITE}`;
    await history.push({ pathname: '/login', search: constants.ADMIN_LITE });
     if (window.ReactNativeWebView) {
     await window.ReactNativeWebView.postMessage(
        JSON.stringify({
          route: '/navigate',
          data: { path }
        })
      );
    }
   
  };
  return props.token != undefined ? (
    <Redirect to='/patient' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' align='middle' className='signinRow center'>
          <Col span={24} flex='auto'>
            <div className='signinContainer'>
              <Card style={{ width: cardSize }}>
                <PortalTitle />
                <h2>
                  {' '}
                  {!isAdminLite && <Link style={{ color: 'black' }} to='/login'>
                    <ArrowLeftOutlined />
                  </Link>}{' '}
                   {isAdminLite &&  <ArrowLeftOutlined onClick={handleBack}/>}
                  &nbsp; Forgot Password{' '}
                </h2>
                <p>
                  Please enter your email and we'll send you a link to
                  reset/set it.
                </p>
                <Form
                  name='normal_login'
                  className='login-form'
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  {captchaRequired && (
                    <Form.Item>
                      <div style={{ marginBottom: 8 }}>
                        Too many requests. Please complete the security check to
                        continue.
                      </div>
                      <TurnstileWidget
                        onToken={(t) => {
                          captchaTokenRef.current = t
                        }}
                        resetRef={capchaResetRef}
                        tokenRef={captchaTokenRef}
                      />
                    </Form.Item>
                  )}
                  <Row justify={'end'}>
                    <Col style={{ marginRight: 'auto' }} flex={'75%'}>
                      <Form.Item
                        name='email'
                        rules={[
                          {
                            required: true,
                            message: 'Please input your Email!',
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <UserOutlined className='site-form-item-icon' />
                          }
                          placeholder='Enter Your Email'
                        />
                      </Form.Item>
                    </Col>
                    <Col flex={'20%'}>
                      <Form.Item>
                        <Button
                          style={{ width: '100%' }}
                          type='primary'
                          htmlType='submit'
                          className='login-form-button'
                        >
                          Send
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </div>
            <Layout.Footer className='main-footer'>
              {util.getCopyrightText()}
            </Layout.Footer>
          </Col>
        </Row>
      </Spin>
    </>
  )
}

ForgotPassword.propTypes = {
  loginUser: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.error,
    message: state.profile.message,
    isLoading: state.profile.isLoading,
    token: util.verifyToken(state.profile.token),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (email, captchaToken) =>
      dispatch(sendResetPasswordLink(null, email, captchaToken)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
